import $ from 'jquery';
import Config from './ClientConfig';
import checkLocalStorage from './checkLocalStorage';
import swal from 'sweetalert';

import AccountsConfig from './../Config';
import { withAppBasePath } from '../app/runtimeConfig';

export function isAuthTokenValid(token){
    var tokenMeta = JSON.parse(atob(token.split(".")[1]));
    var expiry = new Date(tokenMeta.exp  * 1000);
    var current = new Date();
    if (current>expiry){
        return false;
    } else {
        return true;
    }
}

export default class Client {
    constructor (){
        this.accessToken = "";
        this.refreshToken = "";
        this.user = {};
        checkLocalStorage();

        try {
            var rawUser = localStorage.getItem("apiUser");
            var data = rawUser ? JSON.parse(rawUser) : null;

            if (data !== null && data.accessToken !== undefined && isAuthTokenValid(data.accessToken)){
                this.profile = data.profile;
                this.accessToken = data.accessToken;
                this.refreshToken = data.refreshToken;
            } else if (rawUser) {
                localStorage.removeItem("apiUser");
            }
        } catch (e) {
            try {
                localStorage.removeItem("apiUser");
            } catch (storageError) {
                // Storage may be unavailable in embedded/private browser contexts.
            }
        }

        var self = this;
        
        $.ajaxSetup({
            crossDomain:true,
            beforeSend: function(xhr) {
                    if (self.getAuthToken().length > 0)
                xhr.setRequestHeader('Authorization', 'Bearer ' + self.getAuthToken());
            }
        })
    };

    // fuck this!
    getAuthToken () {
        return this.accessToken;
    }

    isAccessTokenValid ( token ) {
        return isAuthTokenValid ( token );
    }

    auth (username, password, callback = function(){}) {
        var data = {
            "username": username,
            "password": password
        };
        var that = this;
        $.ajax({
            url: that.prefix + Config.AUTH_API_URL,
            data: JSON.stringify(data),
            type: "POST",
            contentType: 'application/json',
            processData: false,
            async: true,
            success:function(data){
                if ("access" in data){
                    that.accessToken = data["access"];
                    that.refreshToken = data["refresh"];
                    $.ajax({
                        url: that.prefix + Config.WHOAMI_API_URL,
                        type: "GET",
                        contentType: 'application/json',
                        processData: true,
                        async: true,
                        success:function(data){
                            that.profile = data.profile;
                            localStorage.setItem("apiUser", JSON.stringify({
                                "profile": that.profile,
                                "accessToken": that.accessToken,
                                "refreshToken": that.refreshToken,
                                "time": (new Date()).getTime(),
                                }));
                            window.location.href = AccountsConfig.MAIN_URL;
                        },
                        error: function(xhr, status, error){
                            that.logout();
                        }
                    })
                }
            },
            error: function(xhr, status, error){                
                swal({
                    text: "Wrong username and/or password !",
                    icon: "error",
                  });
            }
        })
    }

    logout (callback = function(){}) {
        if (localStorage.length > 0 || this.user.username){
            var that = this;
            $.ajax({
                url: that.prefix + Config.LOGOUT_API_URL,
                type: "get",
                contentType: 'application/json',
                processData: false,
                async: false,
                success: function(){
                    that.user = {};
                    localStorage.removeItem("apiUser");
                    //window.location.href =  that.prefix;
                },
                error: function(xhr, status, error){
                    //window.location.href = that.prefix;
                }
            })
        }
    }

    reset () {
        this.accessToken = "";
        this.refreshToken = "";
        this.prefix = window.location.protocol + "//" + window.location.host;
        this.user = {};
    }

    getConfig ( queryData, callback = function(){} ) {
        var result = null;
        $.ajax( {
            async: false,
            data: queryData,
            type: 'GET',
            // url: that.prefix + Config.API_URL_CONFIG_FRONT,
            url: Config.BASE_URL + Config.API_URL_CONFIG_FRONT,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json'
            },
            contentType: 'application/json',
            cache: false,
            format: 'jsonp',
            success: function (msg) {
                    result = msg;
            },
            error: function(){}
        } );
        return result;
    }

    setConfigLocalStorage ( callback = function(){} ) {
        let queryData = { };
        let cData = this.getConfig ( queryData );
        let platform = { };
        let identityTexts = { };
        let identityImages = { };
        Object.keys(cData).forEach(key => {
            let fData = cData[key];
            switch ( key ) {
            case "platform":
                fData.forEach ( (d) => {
                platform[d.key] = d.value;
                });
                break;

            case "identityTexts":
                fData.forEach ( (d) => {
                identityTexts[d.key] = d.value;
                });
                break;

            case "identityImages":
                fData.forEach ( (d) => {
                identityImages[d.key] = d.image;
                });
                break;

            default:
                break;
            }     
        });
        let config = { };
        config["platform"] = platform;
        config["identityTexts"] = identityTexts;
        config["identityImages"] = identityImages;
        localStorage.setItem ( "config",  JSON.stringify(config) );
    }

    setLanguagesLocalStorage ( callback = function(){} ) {
        var that = this;
        var result = null;
        $.ajax( {
            async: false,
            type: 'GET',
            data: "",
            url: that.prefix + Config.API_URL_LANGUAGE,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json' 
            },
            contentType: 'application/json',
            cache: false,
            format: 'json',
            success: function (msg) {
                result = msg;
                localStorage.setItem ( "languages",  JSON.stringify(result.Languages) );
            },
            error: function(){}
        } );
        return result;
    }    

    getGeoData ( queryData, callback = function(){} ) {
        var that = this;
        var result = null;
        $.ajax( {
            async: false,
            data: queryData,
            type: 'GET',
            url: that.prefix + Config.API_URL_GEODATA,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json' 
            },
            contentType: 'application/json',
            cache: false,
            format: 'json',
            success: function (msg) {
                    result = msg;
            },
            error: function(){}
        } );
        return result;
    }

    getData ( url, queryData, callback = function(){} ) {
        var result = null;
        $.ajax( {
            async: false,
            data: queryData,
            type: 'GET',
            // url: that.prefix + url,
            url: Config.BASE_URL + url,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json' 
            },
            contentType: 'application/json',
            cache: false,
            format: 'json',
            success: function (msg) {
                    result = msg;
            },
            error: function(){}
        } );
        return result;
    }

    pushData ( url, queryData, callback = function(){} ) {
        var result = null;
        const _queryData = Object.assign ( {}, queryData );    
        $.ajax( {
            async: false,
            data: _queryData,
            type: 'POST',
            // url: that.prefix + url,
            url: Config.BASE_URL + url,
            /* headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json' 
            },
            contentType: 'application/json', */
            cache: false,
            format: 'json',
            success: function (msg) {
                    result = msg;
            },
            error: function(xhr, status, error){
                result = xhr.responseJSON;
            }
        } );
        return result;
    }
    
    callExternalAPI ( url, queryData, callback = function(){} ) {
        var that = this;
        var result = null;
        $.ajax( {
            async: false,
            data: queryData,
            type: 'GET',
            url: that.prefix + url,
            headers: { 
                'Accept': 'application/json',
                'Content-Type': 'application/json' 
            },
            contentType: 'application/json',
            cache: false,
            format: 'json',
            success: function (msg) {
                    result = msg;
            },
            error: function(){}
        } );
        return result;
    }

    forgotPassword(username, callback=function(){}){
        var that = this;
        $.ajax( {
            async: true,
            type: 'GET',
            url: that.prefix + Config.FORGOTPASS_API_URL,
            cache: false,
            data: {username: username},
            processData: true,
            success: function(data){
                        swal({
                            text: "Forgot password...",
                            icon: "success",
                        }).then((value)=>{
                            callback();
                            window.location.href = withAppBasePath("/");
                        });
                    },
            error: function(xhr, status, error){
               
            }
        } );
    }

    resetPass(data, callback = function(){}){
        var that = this;
        $.ajax( {
            async: true,
            type: 'POST',
            //url: base_url + select,
            url: that.prefix + Config.RESETPASS_API_URL,
            // contentType: 'application/json',
            cache: false,
            data: data,
            processData: true,
            success: function(data){
                        callback();
                    },
            error: function(xhr, status, error){
                swal({
                    text: "Send message...",
                    icon: "error",
                  });
            }
        } );
    }
};
